module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/Profile.json
// module id = 609
// module chunks = 1